import { ICommonSettings, ILanguageModel, ILocationPermissionLabelSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigLocationSettings } from "./app-settings-config-location";

export interface IConfigLocationInputState {
  showModal: boolean;
  editingLocationId: string;
}

export interface IConfigLocationInputProps {
  parentData: string;
  languages: ILanguageModel[];
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigLocationInput extends PureComponent<IConfigLocationInputProps, IConfigLocationInputState> {
  formInputName = ["", "locationPermissionLabelSettingsId"];

  constructor(props: IConfigLocationInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showModal: false,
      editingLocationId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingLocationId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingLocation = (id: string) => {
    this.setState({ editingLocationId: id, showModal: true });
  };

  render() {
    const options = [
      {
        id: null,
        name: "Default"
      } as unknown as ILocationPermissionLabelSetting,
      ...(this.props.commonSettings.locationPermissionLabelSettings || [])
    ];

    return (
      <>
        <ConfigLocationSettings
          formInputName={this.formInputName}
          showModal={this.state.showModal}
          closeModal={() => {
            this.closeModal();
          }}
          editingLocationId={this.state.editingLocationId}
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={
            this.props.parentData === "androidConfig" ? "android_location_configuration" : "ios_location_configuration"
          }
          onAddNew={this.openModal}
          onEdit={this.setEditingLocation}
          dropdownTestId={`${
            this.props.parentData === "androidConfig" ? "android_location_configuration" : "ios_location_configuration"
          }GeolocationDropdown`}
          addNewTestId={`${
            this.props.parentData === "androidConfig" ? "android_location_configuration" : "ios_location_configuration"
          }AddNewButton`}
          editTestId={`${
            this.props.parentData === "androidConfig" ? "android_location_configuration" : "ios_location_configuration"
          }EditButton`}
        />
      </>
    );
  }
}
